import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '573013346595';
  const message = '¡Hola! Estuve viendo su página de Atlantis Fish y tengo interés en algunos productos. ¿Podrían darme más información o asesoría? ¡Gracias!';
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 transform hover:scale-110 z-50 animate-bounce group"
      aria-label="Chatear por WhatsApp"
      title="¡Chatea con nosotros por WhatsApp!"
    >
      {/* ICONO OFICIAL DE WHATSAPP */}
      <svg className="w-8 h-8" viewBox="0 0 32 32" fill="currentColor">
        <path d="M16.002 3.2c-7.065 0-12.8 5.735-12.8 12.8 0 2.238.583 4.405 1.691 6.318l-1.779 6.511a1 1 0 001.22 1.22l6.511-1.779a12.77 12.77 0 006.317 1.689c7.065 0 12.8-5.735 12.8-12.8s-5.735-12.8-12.8-12.8zm0 23.2a10.37 10.37 0 01-5.353-1.534.998.998 0 00-.627-.111l-5.1 1.393 1.391-5.101a1 1 0 00-.112-.626A10.78 10.78 0 015.202 16c0-5.978 4.823-10.8 10.8-10.8s10.8 4.822 10.8 10.8-4.823 10.8-10.8 10.8zm5.912-8.471c-.323-.162-1.908-.941-2.204-1.05-.296-.109-.511-.162-.726.162-.215.323-.832 1.05-1.019 1.266-.186.215-.374.243-.697.081-.323-.162-1.362-.501-2.594-1.595-.959-.853-1.607-1.907-1.796-2.23-.186-.323-.02-.497.142-.658.145-.145.323-.374.485-.561.162-.186.215-.323.323-.538.109-.215.055-.404-.027-.566-.081-.161-.726-1.758-.995-2.413-.262-.629-.528-.544-.726-.554-.188-.008-.404-.01-.619-.01a1.195 1.195 0 00-.861.404c-.297.322-1.137 1.112-1.137 2.715s1.163 3.146 1.326 3.364c.162.215 2.284 3.494 5.531 4.763.774.333 1.378.53 1.849.677.777.248 1.485.213 2.045.129.624-.093 1.908-.779 2.177-1.532.27-.754.27-1.4.188-1.531-.081-.129-.297-.21-.619-.373z" />
      </svg>
      <span className="absolute bottom-16 right-1/2 translate-x-1/2 opacity-0 group-hover:opacity-100 pointer-events-none bg-gray-800 text-white text-xs rounded-lg px-3 py-1 transition-all duration-300 z-50 whitespace-nowrap">
        ¡Chatea con nosotros por WhatsApp!
      </span>
    </a>
  );
};

export default WhatsAppButton;
